module.exports = __webpack_public_path__ + "static/brown2-f6eedbb34408e77d4e2a4718b962a77a.svg";